import type { ReactElement } from "react";
import React from "react";
import NextImage from "next/image";
import { imageServiceLoader } from "@/utils/helpers/imageServiceLoader";
import styles from "./Error.module.scss";
import useTranslation from "next-translate/useTranslation";

interface ErrorProps {
  header: string;
  subHeader: string;
}

const Error: React.FC<ErrorProps> = ({ header, subHeader }): ReactElement => {
  const { t } = useTranslation("web-payments");

  return (
    <div className={styles.wrapper}>
      <NextImage
        className={styles.ofImage}
        loader={imageServiceLoader}
        alt={t`HAND_WITH_CARD_ALT_TEXT`}
        src="https://images.onefootball.com/cw/icons/hand-with-yellow-card-v2.svg"
        width={200}
        height={200}
      />

      <p className={styles.header}>{header}</p>
      <p className={styles.subHeader}>{subHeader}</p>
      <div>
        <a
          className={styles.button}
          href={t`ONEFOOTBALL_HOME_URL`}
          rel="noreferrer"
          target="_blank"
        >
          <span>{t`404_NOT_FOUND_GOTO_HOME`}</span>
        </a>
      </div>
    </div>
  );
};

export { Error };
